export interface SpotlightStep {
  target: string; // CSS selector or ref
  title: string;
  message: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

interface SpotlightState {
  active: boolean;
  currentStep: number;
  steps: SpotlightStep[];
}

export const useSpotlight = () => {
  const state = useState<SpotlightState>('spotlight', () => ({
    active: false,
    currentStep: 0,
    steps: [],
  }));

  const start = (steps: SpotlightStep[]) => {
    state.value = {
      active: true,
      currentStep: 0,
      steps,
    };
  };

  const next = () => {
    if (state.value.currentStep < state.value.steps.length - 1) {
      state.value.currentStep++;
    } else {
      close();
    }
  };

  const prev = () => {
    if (state.value.currentStep > 0) {
      state.value.currentStep--;
    }
  };

  const close = () => {
    state.value = {
      active: false,
      currentStep: 0,
      steps: [],
    };
  };

  const currentStepData = computed(() => state.value.steps[state.value.currentStep] || null);

  const isFirst = computed(() => state.value.currentStep === 0);
  const isLast = computed(() => state.value.currentStep === state.value.steps.length - 1);
  const totalSteps = computed(() => state.value.steps.length);

  return {
    state,
    start,
    next,
    prev,
    close,
    currentStepData,
    isFirst,
    isLast,
    totalSteps,
  };
};
